import { useEffect, useState } from 'react';

import { CreditRisk, ReplyQuestion } from '@types';
import cls from './Variables.module.css';


interface Props {
  risk: CreditRisk;
}

interface CatProps {
  title: string;
  list: ReplyQuestion[];
}

const Table = ({ list }: { list: ReplyQuestion[] }) => {
  return (
    <div className={cls.table}>
      {list.map((i, idx) => (
        <div className={cls.line} key={idx}>
          <div className={cls.label}>{i.title}</div>
          <div className={cls.value}>{i.value ? i.value : '---'}</div>
        </div>
      ))}
    </div>
  );
};

const Category = ({ title, list }: CatProps) => {
  const tableData: ReplyQuestion[] = list.filter(l => l.category?.title === title);
  let tables: ReplyQuestion[][] = [];

  if (tableData.length <= 1) {
    tables = [tableData];
  } else {
    const middle = Math.ceil(tableData.length / 2);
    const list1 = tableData.slice(0, middle);
    const list2 = tableData.slice(middle);

    tables = [list1, list2];
  }

  return (
    <div className={cls.category}>
      <div className={cls.title}>{title}</div>

      <div className={cls.row}>
        {tables.map((t, index) => (
          <div className={cls.col} key={index}>
            <Table list={t} />
          </div>
        ))}
      </div>
    </div>
  );
};

export const Variables = ({ risk }: Props) => {
  const [catNames, setCatNames] = useState<string[]>([]);
  const { replyScore } = risk;

  const loadCategories = (): string[] => {
    const catTitles: string[] = [];
    replyScore.forEach((i: ReplyQuestion) => {
      if (i.category?.title) {
        catTitles[i.category.position] = i.category.title;
      }
    });

    return catTitles.filter(t => t);
  };

  useEffect(() => {
    if (replyScore && replyScore.length) {
      setCatNames(loadCategories());
    }
  }, []);

  return (
    <div className={cls.wrap}>
      {catNames.length
        ? catNames.map(c => <Category title={c} list={replyScore} key={c} />)
        : null}
    </div>
  );
};
